import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { pricingService } from '../../../services/pricingService';

const ProductCard = ({ product, isSelected, onSelect, onEdit }) => {
  const getPrimaryImage = () => {
    if (product?.images && Array.isArray(product?.images) && product?.images?.length > 0) {
      return product?.images?.[0];
    }
    return '/assets/images/no_image.png';
  };

  const getMarketplaceStatus = () => {
    const metadata = product?.metadata || {};
    const active = [];
    
    if (metadata?.mercadolivreActive) active?.push('ML');
    if (metadata?.shopeeActive) active?.push('Shopee');
    if (metadata?.amazonActive) active?.push('Amazon');
    if (metadata?.magaluActive) active?.push('Magalu');
    
    return active;
  };

  const activeMarketplaces = getMarketplaceStatus();

  return (
    <div
      className={`
        bg-card border rounded-lg overflow-hidden transition-smooth cursor-pointer
        hover:shadow-brand-md
        ${isSelected ? 'border-primary shadow-brand-sm ring-2 ring-primary/20' : 'border-border'}
      `}
      onClick={onEdit}
    >
      {/* Image */}
      <div className="relative aspect-square bg-muted">
        <img
          src={getPrimaryImage()}
          alt={product?.name || 'Product image'}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.src = '/assets/images/no_image.png';
          }}
        />
        
        {/* Selection Checkbox */}
        <div
          className="absolute top-2 left-2 z-10"
          onClick={(e) => {
            e?.stopPropagation();
            onSelect();
          }}
        >
          <div
            className={`
              w-6 h-6 rounded border-2 flex items-center justify-center transition-smooth
              ${isSelected 
                ? 'bg-primary border-primary' :'bg-white border-border hover:border-primary'
              }
            `}
          >
            {isSelected && <Icon name="Check" size={14} color="white" />}
          </div>
        </div>

        {/* Marketplace Badges */}
        {activeMarketplaces?.length > 0 && (
          <div className="absolute top-2 right-2 flex flex-wrap gap-1">
            {activeMarketplaces?.map(mp => (
              <span
                key={mp}
                className="px-2 py-1 text-xs font-medium bg-success/90 text-white rounded"
              >
                {mp}
              </span>
            ))}
          </div>
        )}
      </div>
      {/* Content */}
      <div className="p-4">
        {/* Name */}
        <h3 className="font-semibold text-foreground mb-1 line-clamp-2 min-h-[2.5rem]">
          {product?.name || 'Sem nome'}
        </h3>

        {/* SKU */}
        <p className="text-xs font-mono text-muted-foreground mb-3">
          SKU: {product?.sku || 'N/A'}
        </p>

        {/* Price and Stock */}
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-muted-foreground">Preço</p>
            <p className="text-lg font-bold text-primary">
              {pricingService?.formatCurrency(product?.price || 0)}
            </p>
          </div>
          
          <div className="text-right">
            <p className="text-xs text-muted-foreground">Estoque</p>
            <p className="text-lg font-bold text-foreground">
              {product?.stock || 0}
            </p>
          </div>
        </div>

        {/* Category and Brand */}
        <div className="mt-3 pt-3 border-t border-border flex items-center justify-between text-xs">
          <span className="text-muted-foreground">{product?.category || 'Sem categoria'}</span>
          <span className="font-medium text-foreground">{product?.brand || 'Sem marca'}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;